define [], () ->
  ($scope, $state, $http) ->



// WEBPACK FOOTER //
// ./components/dashboard/payments/payments.coffee